import { DateUtil } from './../../model/dateutil';
import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { Comparisons, COMPARE } from 'src/app/types/@types/comparisons';
import { AttributeInfo, mSecondsFromEpoch } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { LayerListProviderService } from 'src/app/services/layer-list-provider.service';
import { DateKind } from '../criteria/date-kind/date-kind.component';
import { DateKinds } from '../criteria/date-kinds/date-kinds.component';
import { DateBuffer } from '../criteria/date-buffer/date-buffer.component';
import { SL_ID_PREFIX, SlIdContext } from 'src/app/model/directives/sl-id-context';

export type CriteriaLayout = 'horizontal' | 'vertical';

@Component({
  selector: 'app-search-criterion',
  templateUrl: './search-criterion.component.html',
  styleUrls: ['./search-criterion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SlIdContext,
    {
      provide: SL_ID_PREFIX,
      useValue: 'search-criterion'
    }
  ],
})
export class SearchCriterionComponent implements OnInit {
  @HostBinding('class.layout-horizontal') _layoutHorizontal: boolean = true;
  @HostBinding('class.layout-vertical') _layoutVertical: boolean = false;
  @Input()
  set layout(lyout: CriteriaLayout) {
    this._layoutHorizontal = lyout === 'horizontal';
    this._layoutVertical = !this._layoutHorizontal;
  }

  @Input()
  field: string;

  @Output()
  fieldChange = new EventEmitter<string>();

  private _comparison: string = '';
  @Input()
  set comparison(comp: string) {
    if (this._comparison !== comp) {
      this._comparison = comp;
      this.comparisonChange.emit(this._comparison);
    }
  }
  get comparison(): string {
    return this._comparison;
  }
  @Output()
  comparisonChange = new EventEmitter<string>();

  _value: any = {};
  @Input()
  set value(val: any) {
    if (this._value !== val) {
      this._value = val;
      if (this._ready) {
        this.ngOnInit();
      }
    }
  };
  get value() {
    return this._value;
  }
  @Output()
  valueChange = new EventEmitter<any>();

  @Input()
  layer: SLLayer;

  @Input()
  allowNone = true;

  @Output()
  onReady = new EventEmitter<SearchCriterionComponent>();

  private _filtered: boolean = false;
  @Input()
  set filtered(f: boolean) {
    this._filtered = f;
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }
  get filtered(): boolean {
    return this._filtered;
  }

  @ViewChild('fieldNameSel') fieldNameSel!:ElementRef<HTMLSelectElement>;

  fields: Array<any> = [];

  public dateVal!: string;
  public dateKind!: DateKind;
  public dateKinds!: DateKinds;
  public dateBuffer!: DateBuffer;
  public textVal!: string;
  public numberVal!: number;

  public operators: any;
  public operatorVals!: Array<string>;
  public operatorKeys!: Array<string>;
  public inputType = 'text';
  public itemType = 'text';
  constructor(private layerListProvider: LayerListProviderService, private cdr: ChangeDetectorRef) { }

  private _ready = false;
  ngOnInit() {
    if (this.layer === undefined) {
      return;
    }
    const startInfo = {
      field: this.field,
      comparison: this.comparison,
      val: this.value
    }

    this.fields = this.layer.layerAttributes.slice(0);


    if (this.allowNone === true) {
      this.fields.unshift({ name: '', type: '', value: '' });
    }
    this.cdr.detectChanges();

    if (startInfo.field === undefined) {
      startInfo.field = this.fields[0].name;
      startInfo.val = '';
    } else {
      startInfo.val = this.value;
    }
    if (this.operators === undefined) {
      this.UpdateOperators(startInfo.field);
      this.cdr.detectChanges();
      if (startInfo.comparison === undefined) {
        startInfo.comparison = this.operatorKeys[0];
      }
    }

    if (this.fields.length > 0) {
      this.AttSelected(startInfo.field);
    }
    if (!!startInfo.comparison) {
      this.comparison = startInfo.comparison;
      this.CompareChanged(true);
      this.cdr.detectChanges();
    }
    if (!!startInfo.val) {
      this.SetVal(startInfo.val);
    }
    this._ready = true;
 
  }
  AttSelected(attName?) {
    // if(!attName) return;
    if (this.field === attName) return;
    const oldComparison = this._comparison;
    const oldVal = this._value;
    this.UpdateOperators(attName);
    this.field = attName;
    this.fieldChange.emit(attName);
    if (Object.values(this.operators).indexOf(oldComparison) > -1) {
      this.comparison === oldComparison;
      this.comparisonChange.emit(this.comparison)
      this.value = oldVal;
      this.cdr.detectChanges();
      return;
    }
    for (const operator in this.operators) {
      if (this.operators.hasOwnProperty(operator)) {
        this.comparison = this.operators[operator];
        this.comparisonChange.emit(this.comparison)
        this.cdr.detectChanges();
        return;
      }
    }
    if (this.operatorKeys.length === 0) {
      this.comparison = '';
    } else {
      this.comparison = this.operatorKeys[0];

    }
    this.CompareChanged(true);
    // this.comparisonChange.emit(this.comparison);
    this.cdr.detectChanges();
  }
  UpdateOperators(field) {
    if ([null, undefined].indexOf(field) > -1) {
      this.operators = {};
      this.operatorKeys = [];
      return;
    }

    const info = this.NameToField(field);
    if (!info) return;
    this.field = field;
    switch (info?.type) {
      case 'numeric':
      case 'float':
      case 'double':
      case 'int':
      case 'integer':
      case 'time':
        this.operators = Comparisons.GetNumeric();
        this.inputType = 'numeric';
        if (info.type === 'time') {
          this.inputType = 'time';
        }
        break;
      case 'memory':
        this.operators = Comparisons.GetMemory();
        this.inputType = 'memory';
        break;
      case 'text':
      case 'text input':
      case 'text area':
      case 'string':
      case 'cg_url':
      case 'url':
      case 'date':
        this.operators = Comparisons.GetString();
        this.inputType = 'text';
        if (info.type === 'date') {
          this.operators = Comparisons.GetDate();
        }
        break;
      case 'boolean':
        this.operators = Comparisons.GetBoolean();
        this.inputType = 'boolean';
        break;
      default:
        this.operators = {};
        break;
    }
    this.operatorKeys = Comparisons.GetKeys(this.operators);
    this.operatorVals = [];
    for (const key of this.operatorKeys) {
      this.operatorVals.push(this.operators[key]);
    }
    this.itemType = info.type;
    this.cdr.detectChanges();
    requestAnimationFrame(() => {

      const matches = document.getElementsByClassName('operators');
      if (matches.length > 0) {
        var evt = new Event("change", { "bubbles": true, "cancelable": true });
        matches[0].dispatchEvent(evt);
      }
    })
  }

  CompareChanged(notify: boolean = true) {
    if (notify === true) {
      this.comparisonChange.emit(this.comparison);
    }
    if (this.itemType === 'date') {

      switch (this.comparison) {
        case COMPARE.DATE_NOT_BETWEEN:
        case COMPARE.DATE_BETWEEN:
          this.inputType = 'date-buffer';
          break;
        case COMPARE.DATE_IS_A:
        case COMPARE.DATE_IS_NOT_A:
          this.inputType = 'date-kind';
          break;
        case COMPARE.DATE_IS_ONE_OF:
        case COMPARE.DATE_IS_NOT_ONE_OF:
          this.inputType = 'date-kinds'
          break;
        default:
        case COMPARE.DATE_EQUALS:
        case COMPARE.DATE_AFTER:
        case COMPARE.DATE_BEFORE:
          this.inputType = 'date-value';
          break;

      }
    }
    this.cdr.detectChanges();
  }
  SetVal(val: any) {
    switch (this.inputType) {
      case 'text':
        this.textVal = val;
        break;
      case 'numeric':
        this.numberVal = val;
        break;
      case 'date-value':
        this.dateVal = val;
        break;
      case 'date-buffer':
        this.dateBuffer = val;
        break;
      case 'date-kind':
        this.dateKind = val;
        break;
      case 'date-kinds':
        this.dateKinds = val;
        break;
    }
    this.cdr.detectChanges();
  }
  ValChanged(_val: any) {
    /*
    public dateVal: mSecondsFromEpoch;
  public dateKind: DateKind;
  public dateKinds: DateKinds;
  public dateBuffer: DateBuffer;
  public textVal: string;
  public numberVal: number;
  */
    switch (this.inputType) {
      case 'text':
        this._value = this.textVal;
        break;
      case 'numeric':
        this._value = '' + this.numberVal;
        break;
      case 'date-value':
        this._value = '' + this.dateVal;
        break;
      case 'date-buffer':
        this._value = this.dateBuffer;
        // DateUtil.DateBufferToCriterion(this.field, this.dateBuffer, this.comparison === COMPARE.DATE_NOT_BETWEEN).value;
        break;
      case 'date-kind':
        this._value = this.dateKind;
        break;
      case 'date-kinds':
        this._value = this.dateKinds;
        break;
    }
    this.valueChange.emit(this._value);
    this.cdr.detectChanges();
  }
  NameToField(fieldName: string): AttributeInfo | any {
    for (const field of this.fields) {
      if (field.name === fieldName) {
        return field;
      }
    }
    return { type: '' };
  }
  IsSingleDate(inputType) {
    return ['date-value', 'date-buffer', 'date-before', 'date-after'].indexOf(inputType) > -1;
  }
}
